module.exports = __webpack_public_path__ + "img/enerman-etisol_new_light.ad05ee67.svg";